<template>
  <div class="myuploader-3">
    <van-cell-group class="uploader-box" :border="false">
      <!-- <template #title>
        <div v-html="title"></div>
      </template> -->
      <div class="words" v-if="words" style="color: rgba(69, 90, 100, 0.6);font-size:14px;margin-bottom:10px;">{{words}}</div>
      <!-- 示例图片 -->
      <div class="uploader-subbox" v-if="showTemp && temp.length>0">
        <div class="uploader-subtitle">示例图片</div>
        <van-row type="flex" gutter="20">
          <van-col @click="showPic(temp)">
            <van-image width="120" fit="contain" height="80" :src="temp" />
            <!-- <div class="text">示例1</div> -->
          </van-col>
        </van-row>
      </div>

      <!-- 图片上传 -->
      <div class="van-uploader">
        <div class="van-uploader__wrapper">

        </div>
      </div>

      <!-- 历史图片 -->
      <div class="van-uploader" v-if="showHistory">
        <div class="uploader-subtitle" v-show="showText">已上传图片</div>
         <!-- 历史图片 -->
        <div class="van-uploader__wrapper">

          <div class="van-uploader__preview" v-for="(hitem, hindex) in history" :key="hindex" @click="showPic(history, hindex)">
            <van-image width="80" fit="contain" height="80" :src="hitem.filepath">
              <!-- <i class="van-icon van-icon-clear van-uploader__preview-delete" v-if="hitem.is_check == '0'||hitem.checked == '0'||hitem.predict_unlock_id" @click.stop="deleteImg(hitem.id,hitem)"></i> -->
              <i class="van-icon van-icon-clear van-uploader__preview-delete" @click.stop="deleteImg(hitem.id,hitem)"></i>
            </van-image>
          </div>

          <!-- 图片上传 -->
          <div class="van-uploader__preview" @click="showPic(image.filepath?image.filepath:(image.src))"
            v-for="(image,index) in images" :key="image.serverId">
            <div class="van-image van-uploader__preview-image">
              <img :src="(image.filepath?image.filepath:(image.src ? (image.src):defaultImage))" class="van-image__img"
                style="object-fit: cover;">
            </div>
            <!-- <div class="van-uploader__mask" v-if="isLoading">
              <div class="van-loading van-loading--circular van-uploader__loading">
                <span class="van-loading__spinner van-loading__spinner--circular">
                  <svg viewBox="25 25 50 50" class="van-loading__circular">
                    <circle cx="50" cy="50" r="20" fill="none"></circle>
                  </svg>
                </span>
              </div>
              <div class="van-uploader__mask-message">上传中...</div>
            </div> -->
            <!-- <div class="van-uploader__mask">
              <i class="van-icon van-icon-close van-uploader__mask-icon"></i>
              <div class="van-uploader__mask-message">上传失败</div>
            </div> -->
            <i class="van-icon van-icon-clear van-uploader__preview-delete"
              @click.prevent.stop="removeImg(true, image,index)"></i>
            </div>
            <!-- <div class="van-uploader__upload" @click="chooseImage()" v-if="this.images.length<num||useNum"> -->
              <div class="van-uploader__upload" @click="chooseImage()" v-if="this.images.length+this.history.length<num"> 
              <i class="van-icon van-icon-plus van-uploader__upload-icon"></i>
            <div class="van-uploader__input"></div>
          </div>

        </div>
      </div>
    </van-cell-group>
  </div>
</template>

<script>
  import Vue from "vue";
  import {
    Toast,
    ImagePreview,
    Dialog
  } from 'vant'
  import defaultImage from '@/assets/image.jpg'
  import {
    DeleteImg,
    deleteCheckItem
  } from '@/api/api'
    import { DownloadImage } from '@/api/patient'
import { isPCWechat } from "@/utils/utils";
      
  Vue.use(Toast)
  Vue.use(ImagePreview)
  Vue.use(Dialog)

  export default {
    name: 'ImageUploader',
    props: {
      value: {
        type: Array
      },
      //   prevImages: {
      //       type: Array,
      //       default: []
      //   },
      title: {
        type: String,
        default: '上传图片'
      },
      note: {
        type: String,
        default: ''
      },
      num: {
        type: Number,
        default: 1
      },
      showTemp: {
        type: Boolean,
        default: true
      },
      temp: {
        type: String,
        default: ''
      },
      showHistory: {
        type: Boolean,
        default: true
      },
      history: {
        type: Array,
        default: ()=>[]
      },
      words: {
        type: String,
        default: ''
      },
      sourceType: {
        type: Array,
        default:()=>['album', 'camera']// 可以指定来源是相册还是相机，默认二者都有
      }, 
      useNum:{
        type:Boolean,
        default:false,
      }
    },
    data() {
      return {
        defaultImage: defaultImage,
        images: [],
        src: [],
        isLoading: false,
        showText:true,
      };
    },
    // computed: {
    //   canUp() {
    //     if (this.num == 1 && (this.num - this.history.length - this.images.length) > 0) {
    //       return true
    //     } else {
    //       return false
    //     }
    //   }
    // },
    created() {
      if(this.$route.name=="Apply") this.showText=false
      if(this.$route.name=="AddAgent") this.showText=false
      this.images = this.value
    },
    methods: {
      updateValue: function (value) {
        if (value === null) value = defaultImage
        this.$emit('input', value)
      },
      chooseImage(event) {
        if (isPCWechat()) {
          console.log('请使用手机端微信进行拍照上传')
          Toast("请使用手机端微信进行拍照上传");
          return false;
        }
        this.wx.ready(() => {
          this.wx.chooseImage({
            count: this.num,
            sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
            sourceType: this.sourceType, // 可以指定来源是相册还是相机，默认二者都有
            success: async (res) => {
              try {
                for (let index = 0; index < res.localIds.length; index++) {
                  const serverId = res.localIds[index];
                  await this.uploadImage(serverId);
                }
              } catch (err) {
                Toast(err.response.data.message);
              }
            },
            fail: function (err) {
              Toast('选图失败');
              console.log(err)
            }
          })
        })
      },
      uploadImage(serverId) {
        return new Promise((resolve, reject) => {
          this.wx.uploadImage({
            localId: serverId,
            isShowProgressTips: 1,
            success: (res) => {
              var serverId = res.serverId; // 返回图片的服务器端ID
              this.isLoading = true
              DownloadImage({
                  params: {
                    serverId: serverId
                  }
                }).then((res) => {
                  this.images.push({
                    serverId: serverId,
                    src: this.checkImg(res.data)
                  })
                  this.updateValue(this.images)
                  this.isLoading = false
                  resolve()
                })
                .catch((err) => {
                  //  reject(err.response.data.message)
                  console.log(err)
                  this.isLoading = false
                  reject(err)
                })
            }
          });
        });
      },
    checkImg(img) {
      var url = img;
      if(img.indexOf('http') == -1) {
        url = this.baseUrl + img
      }
      return url 
    },
      removeImg(is_new, item, index) {
        Dialog.confirm({
            message: '确定删除？',
          })
          .then(() => {
            console.log("item",item)
            console.log("item.src",item.src)
            DeleteImg({
              src: item.src
            }).then(res => {
              this.images.splice(index, 1)
              Toast('删除成功')
            }).catch(err => {
              Toast('删除失败')
            })
          })
          .catch((err) => {
            console.log(err);
          });
      },
      deleteImg(id,item) {
        this.$emit('deleteCI', id,item)
      },
      onImgError(item, $event) {
        console.log(item, $event);
      },
      showPic(route, index) {
        console.log(route, index)
        this.src = []
        if (Array.isArray(route)) {
          route.forEach(ele => {
            this.src.push(ele.filepath)
          })
        } else {
          this.src.push(route)
        }
        this.$nextTick(() => {
          ImagePreview({
            images: this.src,
            showIndex: true,
            loop: false,
            startPosition: index ? index : 0,
          })
        })
      },
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  .myuploader-3 {
    .van-cell-group__title {
      padding: 10px;
      font-size: 16px;
      color: #333;
    }

    .uploader-box {
      box-sizing: border-box;
      padding: 10px 15px 10px 0;
      // border-top: 1px solid rgba(0,0,0,0.07);
      // border-bottom: 1px solid rgba(0,0,0,0.07);
      overflow: hidden;

      .van-uploader {
        border-bottom: #eee solid 1px;
        // margin-bottom: 20px;
        border:none;
        .van-uploader__wrapper{
          display: flex;
          justify-content:flex-start;
          .van-uploader__upload{
            margin-right: 15px;
            // flex:1  0;
          }
          .van-uploader__preview{
            margin-right: 15px;
          }
        }
        .text {
          margin-top: 5px;
          color: #666;
          text-align: center;
        }

        .van-col {
          margin-bottom: 15px;
          position: relative;
          margin-right: 10px;
        }
      }

      .uploader-subtitle {
        margin: 0;
        padding: 32px 0px 16px;
        color: rgba(69, 90, 100, 0.6);
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
      }

      .uploader-subbox:first-child {
        .uploader-subtitle {
          padding-top: 0;
        }
      }

      .uploader-subbox:last-child {
        margin-bottom: 0;
        border-bottom-width: 0;
      }
    }

    .van-image {
      background: #ffffff;
      .van-uploader__preview-delete {
        background: white !important; color: #aaa; font-size: 16px; height: 16px; width: 16px; border-radius: 16px; top: -6px; right: -6px; 
        // box-shadow: 0 0 0 1px #fff;
        box-shadow:none !important;
      }
    }
    i.van-uploader__preview-delete {
      background: white; color: #aaa; font-size: 16px; height: 16px; width: 16px; border-radius: 16px; top: -6px; right: -6px; 
      // box-shadow: 0 0 0 1px #fff;
      box-shadow:none !important;
    }
  }
.van-overlay {
    background-color: rgba(0, 0, 0, 0.6);
}
</style>